const backendConfig = {
    apiEndpoint: '/api/v1',
    business: 'pedi2',
};

export default backendConfig;